module.exports = "/_next/static/images/minus-a39d4349a4ad3c685bfefc068349747c.svg";